import React from 'react';

import { Box, Stack, Typography } from '@mui/material';

interface Props {
  actions?: React.ReactNode;
  subtitle: string;
  title: string;
}

export default function SectionHeading({ title, subtitle, actions }: Props) {
  return (
    <Stack direction={{ xs: 'column', md: 'row' }} justifyContent="space-between" spacing={2} sx={{ mb: 2 }}>
      <Box>
        <Typography variant="h4">{title}</Typography>
        <Typography variant="body2" color="text.secondary">
          {subtitle}
        </Typography>
      </Box>
      {actions && (
        <Stack direction="row" spacing={1}>
          {actions}
        </Stack>
      )}
    </Stack>
  );
}
